import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { z } from 'zod';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';
import { requireSystemAdmin } from '~/utils/guards';

/**
 * Connectors admin route (`/integrations/connectors`). Super-admin only — the
 * parent integrations layout is unguarded, so the guard lives here (mirrors the
 * sibling `products` / `catalog-images` routes). Lazy-loaded to stay off the
 * initial authenticated bundle.
 */
const ConnectorsPage = lazy(() => import('~/features/integrations/pages/connectors-page'));

// Persist the page-local subsidiary scope in the URL (opaque `sc`) so a reload
// or shared link keeps the picked subsidiary — matches the sibling routes.
const searchSchema = z.object({
  sc: z.string().optional(),
});

export const Route = createFileRoute('/_authenticated/_tenant/integrations/connectors')({
  validateSearch: searchSchema,
  beforeLoad: requireSystemAdmin(),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <Suspense fallback={<PageSkeleton />}>
      <ConnectorsPage />
    </Suspense>
  );
}
